const getters = {
    baseUri: state => state.global.baseUri
  }
  export default getters


// WEBPACK FOOTER //
// ./src/store/getters.js